module.exports = __webpack_public_path__ + "static/media/FlyerRight.50a27a2c.png";